import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import GetUserId from 'Components/UserLogged/UserId/UserId';
import './BenefitsPanel.css'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import WordMonthDate from 'Components/DateChanged/WordMonthDate/WordMonthDate';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const BenefitsPanel = ({
    usersSelected,
    onUpdateBenefitsIdSelected,
    benefitsIdSelected
}) => {
    const userIdLogged = GetUserId();
    const [idBenefit, setIdBenefit] = useState(null);
    const [valueBenefit, setValueBenefit] = useState(null);
    const [idItemBenefit, setIdItemBenefit] = useState(null);
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);
    const [isChangeCostDay, setIsChangeCostDay] = useState('N');
    const [dtStartBenefit, setDtStartBenefit] = useState(null);
    const [dtFinishBenefit, setDtFinishBenefit] = useState(null);
    const [isRealValue, setIsRealValue] = useState('N');

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [recordsBenefitsByUserId, setRecordsBenefitsByUserId] = useState(null);
    const readOnlyAttributes = !(inserting || updating);

    const [attributesDetailBenefitPanel, setAttributesDetailBenefitPanel] = useState(null);
    const [itemBenefitList, setItemBenefitList] = useState(null);

    const [loadingBenefitPanel, setLoadingBenefitPanel] = useState(null);

    const messageIsChangeCostDay = () => {
        if (inserting) {
            return ('Inserir orçamento detalhado')
        } else {
            return ('Atualizar orçamento detalhado')
        }
    }

    useEffect(() => {
        const onReady = async () => {
            await callToSetItemBenefitList();
        };

        onReady();
    }, [])

    async function callToSetItemBenefitList() {
        const itemBenefitList = await ExecuteAxios.api('get', `/item-benefits/item-benefit-lookup`);
        setItemBenefitList(itemBenefitList);
    }
    const itemsBenefitsOptions = OptionsDataByAttributePath(itemBenefitList, ['dsItem'], null, true);

    const attributeList = [
        { name: "id", value: idBenefit, setter: setIdBenefit },
        { name: "value", value: valueBenefit, setter: setValueBenefit },
        { name: "itemId", value: idItemBenefit, setter: setIdItemBenefit, comboboxOptions: itemsBenefitsOptions },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate },
        {
            name: "isAddAnnualBudget",
            value: isChangeCostDay,
            setter: setIsChangeCostDay,
            customMessage: messageIsChangeCostDay()
        },
        { name: "dtStart", value: dtStartBenefit, setter: setDtStartBenefit, isVisible: isChangeCostDay === 'S', isMandatory: (isChangeCostDay === 'S' ? 'S' : 'N') },
        { name: "dtFinish", value: dtFinishBenefit, setter: setDtFinishBenefit, isVisible: isChangeCostDay === 'S', isMandatory: (isChangeCostDay === 'S' ? 'S' : 'N') },
        {
            name: "isRealValue",
            value: isRealValue,
            setter: setIsRealValue,
            readOnlyPanelList: true,
            checks: [
                { field: 'isRealValue', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        }
    ];

    useEffect(() => {
        reloadListBenefits()
    }, []);


    useEffect(() => {
        if (isChangeCostDay !== 'S') {
            setDtStartBenefit(null)
            setDtFinishBenefit(null)
        }
    }, [isChangeCostDay]);

    useEffect(() => {
        setUpdating(false)
        setInserting(false)
        onUpdateBenefitsIdSelected([])
    }, [usersSelected]);

    useEffect(() => {
        reloadListBenefits()
        if ((!usersSelected || usersSelected.length != 1) && updating) {
            setUpdating(false)
        }

        if (!usersSelected || usersSelected.length > 1) {
            onUpdateBenefitsIdSelected([])
        }
    }, [usersSelected, inserting, updating]);

    useEffect(() => {
        reloadListBenefits();
        getDetailInformation();
    }, [inserting, updating]);

    const fetchDataDetail = async (benefitIdSelected) => {
        const parameters = { id: benefitIdSelected }
        const benefits = await ExecuteAxios.api('get', `/benefits/benefits-by-id/`, { params: parameters })
        if (benefits) {
            setAttributesDetailBenefitPanel(benefits)
            ApplyAttributes.applyAttributes(benefits, attributeList)
        }

        if (!benefitIdSelected || benefitIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        getDetailInformation();
    }, [benefitsIdSelected]);

    function getDetailInformation() {
        if (benefitsIdSelected && benefitsIdSelected.length === 1) {
            fetchDataDetail(benefitsIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }

    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%'
    };

    async function getBenefitsRecords(userSelected) {
        const parameters = { userId: userSelected }
        const benefits = await ExecuteAxios.api('get', `/benefits/benefits-by-user-id/`, { params: parameters, responseType: 'text' });
        setRecordsBenefitsByUserId(benefits);
        RemoveIdsNotFound.remove(benefits, onUpdateBenefitsIdSelected, benefitsIdSelected)
    }

    const getBenefitsPanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={onUpdateBenefitsIdSelected}
                    idsSelected={benefitsIdSelected}
                    data={recordsBenefitsByUserId}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailBenefitPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postBenefit() {
        if (usersSelected && usersSelected[0]) {
            try {
                setLoadingBenefitPanel(true)
                const response = await ExecuteAxios.api('post', `/benefits/`, {
                    userId: usersSelected[0],
                    userLogged: userIdLogged,
                    itemBenefitsId: idItemBenefit,
                    valueBenefits: valueBenefit,
                    isAddAnnualBudget: isChangeCostDay,
                    dtStartBenefit: dtStartBenefit,
                    dtFinishBenefit: dtFinishBenefit,
                    isRealValue: isRealValue ? isRealValue : 'N'
                });

                if (response) {
                    await reloadListBenefits()
                }

                return response
            } finally {
                setLoadingBenefitPanel(false)
            }
        }
    }

    async function putBenefit() {
        if (usersSelected && usersSelected[0]) {
            try {
                setLoadingBenefitPanel(true)
                const response = await ExecuteAxios.api('put', `/benefits/`, {
                    id: idBenefit,
                    userId: usersSelected[0],
                    userLogged: userIdLogged,
                    itemBenefitsId: idItemBenefit,
                    valueBenefits: valueBenefit,
                    isAddAnnualBudget: isChangeCostDay,
                    dtStartBenefit: dtStartBenefit,
                    dtFinishBenefit: dtFinishBenefit,
                    isRealValue: isRealValue ? isRealValue : 'N'
                });

                if (response) {
                    await reloadListBenefits()
                }
    
                return response;
            } finally {
                setLoadingBenefitPanel(false)
            }
        }
    }

    async function deleteFunction() {
        if (usersSelected && usersSelected[0]) {
            try {
                setLoadingBenefitPanel(true)

                const response = await ExecuteAxios.api('delete', `/benefits/`, {
                    params: { id: idBenefit }
                });

                if (response) {
                    await reloadListBenefits()
                }
                return response
            } finally {
                setLoadingBenefitPanel(false)
            }
        }
    }

    async function reloadListBenefits() {
        if (usersSelected && usersSelected.length === 1) {
            await getBenefitsRecords(usersSelected[0])
        } else {
            await getBenefitsRecords(null)
        }
    }

    return (
        <LoadingIndicator loaded={!loadingBenefitPanel}>
            <Panel
                style={userControlPanelStyle}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={benefitsIdSelected && benefitsIdSelected.length === 1}
                putFunction={putBenefit}
                enableNewRecord={true}
                canNewRecord={benefitsIdSelected}
                postFunction={postBenefit}
                enableDelete={true}
                canDelete={true}
                deleteFunction={deleteFunction}
                canViewCRUD={true}
                readOnly={!(usersSelected && usersSelected.length === 1)}
                recordsSelected={benefitsIdSelected}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailBenefitPanel}
                attributeList={attributeList}
                onUpdateIdSelected={onUpdateBenefitsIdSelected}
            >
                {getBenefitsPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );
};

export default BenefitsPanel;


